import { createActions } from 'redux-actions';
import { apiActions as commonApiActions, apiResourceActionCreator } from '../common';

export const API_ENDPOINT = 'data-gov';
export const LICENSEE_ENDPOINT = `${API_ENDPOINT}/search/afs-licensee`;

const actions = createActions({
  DATA_GOV: {
    API: {
      LICENSEES: {
        GET: apiResourceActionCreator('afsLicensees')
      }
    },
    LICENSEES: {
      GET: (query) => ({ query })
    }
  }
});

export const apiActions = {
  dataGov: {
    licensees: {
      get: (authToken, query) => commonApiActions.authenticated.get(`${LICENSEE_ENDPOINT}?query=${encodeURIComponent(query)}`, authToken, actions.dataGov.api.licensees.get)
    }
  }
};

export default actions;



// WEBPACK FOOTER //
// ./src/state/modules/data-gov/actions.js